export default function Hero() {
  const stats = [
    { label: '每日爆料追踪', value: '全天候更新' },
    { label: '覆盖范围', value: '网红+明星双线' },
    { label: '内容安全', value: '人工审核把关' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] pt-16 md:pt-20 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="absolute top-0 right-0 w-[500px] h-[500px] md:w-[700px] md:h-[700px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] md:w-[500px] md:h-[500px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4 pointer-events-none"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-6 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              <span>17吃瓜爆料 · 17黑料吃瓜</span>
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              17吃瓜网
              <br className="lg:hidden" />
              <span className="text-primary-600">全网黑料实时追踪</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-foreground-600 font-medium mb-4">
              吃瓜第一线，爆料不隔夜
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              17吃瓜网专注网红黑料与明星爆料的即时聚合，覆盖娱乐圈黑料、内幕吃瓜与17c吃瓜黑料爆料等热门领域。每日追踪最新17吃瓜黑料网动态，为吃瓜群众提供一手娱乐资讯与深度事件解读。当前热门：顶流艺人隐私风波持续发酵，多位网红被曝税务问题，娱乐圈地震不断。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center px-4 py-3 rounded-xl bg-background-50/80">
                  <div className="text-lg md:text-xl font-bold text-primary-600 whitespace-nowrap">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#ranking');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                查看最新热搜
              </a>
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#topics');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-foreground-200 hover:border-primary-400 hover:text-primary-600 text-foreground-700 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                浏览话题广场
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-200/50 via-background-200 to-accent-200/50"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center p-6">
                  <div className="w-20 h-20 md:w-24 md:h-24 mx-auto rounded-2xl bg-primary-500 flex items-center justify-center mb-4">
                    <i className="ri-eye-line text-4xl md:text-5xl text-background-50"></i>
                  </div>
                  <div className="font-heading font-bold text-xl md:text-2xl text-foreground-800 mb-2">
                    全网黑料一网打尽
                  </div>
                  <div className="text-sm text-foreground-500">
                    17吃瓜黑料网 · 实时追踪娱乐圈动态
                  </div>
                  <div className="mt-4 flex flex-wrap justify-center gap-2">
                    <span className="px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">网红黑料</span>
                    <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium whitespace-nowrap">明星爆料</span>
                    <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium whitespace-nowrap">内幕吃瓜</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}